"use client"

import dynamic from "next/dynamic"
import type { IData } from "@/types"

const Login = dynamic(() => import("./Login"), { ssr: false })
const Register = dynamic(() => import("./Register"), { ssr: false })

export default function AuthModals({ data }: { data: IData }) {
  return (
    <>
      <Login />
      <Register data={data} />
    </>
  )
}
